/** @jsx jsx */
import { useContext } from 'react';
import { jsx } from '@emotion/core';

import { ChallengeListDetailsContext } from '..';
import { ChallengeDescription, ChallengeDescriptionSection } from 'components';

export default function DescriptionSection() {
  const { challenge, challengeStatus, challengeResult } = useContext(
    ChallengeListDetailsContext,
  );

  return (
    <ChallengeDescriptionSection>
      <ChallengeDescription
        challengeStatus={challengeStatus}
        challenge={challenge}
        challengeResults={challengeResult}
      />
    </ChallengeDescriptionSection>
  );
}
